import React, { Component, Fragment } from "react";
import classnames from "classnames";
import _ from "i18n";

import { SLIDES_TABS } from "Config";

import { ICONS, SvgIcon } from "../Common/Icons";
import SearchBox from "../Common/filters/SearchBox";
import NotFoundV2 from "../NotFound/NotFoundV2";
import Slide from "../Dashboard/Slide";

import styles from "./PreparePresentation.local.scss";
import { getLabelsByLng } from "../../utils";

class SlidesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedIndex: ["STANDARD", "CREATED", "ALL"],
      selectedStatus: "all",
      activatedSlide: null,
      disposition: "GRID",
      slidesSearch: ""
    };
  }

  handleChangeSlidesSearch = search => {
    this.setState({ slidesSearch: search.toLowerCase() });
  };

  handleSelectSlidesType = index => {
    this.setState({
      selectedStatus: index
    });
  };

  isAlreadySelected = id => {
    const {
      composition: { slidesOrder }
    } = this.props;

    for (let i = 0; i < slidesOrder.length; i++) {
      if (id === slidesOrder[i]) {
        return true;
      }
    }
    return false;
  };

  handleSelectSlide = slide => {
    this.setState({ activatedSlide: slide });
  };

  setDisposition = dispo => {
    this.setState({ disposition: dispo });
  };

  handleCancelAddSlide = () => {
    this.setState({
      ...this.state,
      activatedSlide: this.props.slideId,
      slidesSearch: ""
    });
    this.props.cancelAddSlide();
  };

  handleValidateAction = () => {
    let { activatedSlide } = this.state;
    this.setState({
      ...this.state,
      activatedSlide: null,
      slidesSearch: ""
    });
    this.props.validateAction(activatedSlide);
  };

  renderSlidesByType = slides => {
    const { disposition } = this.state;
    return (
      <div>
        {disposition === "GRID"
          ? this.renderSlidesGridDisposition(slides)
          : this.renderSlidesListDisposition(slides)}
      </div>
    );
  };

  renderSlidesGridDisposition = slides => {
    const { lng } = this.props;
    let { activatedSlide } = this.state;
    return (
      <div className={styles.slides_list}>
        {slides.map((slide, i) => {
          return (
            <div
              className={classnames(
                styles.slides_min,
                this.isAlreadySelected(slide.id) && styles.already_selected
              )}
              key={"slideList_" + i}
            >
              <span className={styles.slide_label}>
                {getLabelsByLng(slide.labels, lng)}
              </span>
              <div
                className={classnames(
                  styles.slide_frame,
                  activatedSlide &&
                    activatedSlide.code == slide.code &&
                    styles.slide_activated
                )}
              >
                <Slide
                  key={slide.id}
                  slide={slide}
                  isResponsive={false}
                  handleSlideListOnClick={() => this.handleSelectSlide(slide)}
                />
                <img
                  src={"/img/icons/check-circle.svg"}
                  alt={""}
                  className={styles.arrow_left}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  renderSlidesListDisposition = slides => {
    const { lng } = this.props;
    let { activatedSlide } = this.state;
    return (
      <div className={styles.labels_list}>
        {slides.map((slide, i) => {
          return (
            <Fragment>
              <div
                className={classnames(
                  styles.slide_frame,
                  activatedSlide &&
                    activatedSlide.code == slide.code &&
                    styles.slide_activated
                )}
              >
                <div
                  className={styles.slide_labels_list}
                  key={"slideList_" + i}
                  onClick={() => this.handleSelectSlide(slide)}
                >
                  <span className={styles.slide_label}>
                    {getLabelsByLng(slide.labels, lng)}
                  </span>
                </div>
                <img
                  src={"/img/icons/check-circle.svg"}
                  alt={""}
                  className={styles.arrow_left}
                />
              </div>
            </Fragment>
          );
        })}
      </div>
    );
  };

  renderActionsBox = () => {
    return (
      <div className={styles.actions_box}>
        <SearchBox
          placeholder={_("search")}
          onChange={this.handleChangeSlidesSearch.bind(this)}
        />
        <button
          type="button"
          className={classnames(
            styles.disposition_button,
            this.state.disposition === "GRID" && styles.active
          )}
          onClick={() => this.setDisposition("GRID")}
        >
          <SvgIcon icon={ICONS.GRID} />
        </button>
        <button
          type="button"
          className={classnames(
            styles.disposition_button,
            styles.disposition_button_list,
            this.state.disposition === "LIST" && styles.active_list
          )}
          onClick={() => this.setDisposition("LIST")}
        >
          <SvgIcon icon={ICONS.MENU} />
        </button>
      </div>
    );
  };

  render() {
    const { slides, lng, title } = this.props;
    let { selectedStatus, activatedSlide } = this.state;
    const filteredSlides = slides[selectedStatus]
      ? slides[selectedStatus].filter(
          slide =>
            slide.labels[lng].toLowerCase().indexOf(this.state.slidesSearch) >
            -1
        )
      : [...slides.standard, ...(slides.created || slides.used || [])].filter(
          slide =>
            slide.labels[lng].toLowerCase().indexOf(this.state.slidesSearch) >
            -1
        );
    return (
      <Fragment>
        <div className={styles.title_side_bar}>{_(title)}</div>
        <div className={styles.tabs}>
          {SLIDES_TABS.map((type, i) => {
            return (
              <div
                key={i}
                className={
                  styles.tab_badge +
                  " " +
                  (selectedStatus === type.value ? styles.tab_badge_active : "")
                }
                onClick={() => this.handleSelectSlidesType(type.value)}
              >
                {_(type.label)}{" "}
                {slides[type.value]
                  ? `(${slides[type.value].length})`
                  : `(${
                      [
                        ...slides.standard,
                        ...slides.used,
                        ...(slides.created || [])
                      ].length
                    })`}
              </div>
            );
          })}
        </div>
        {this.renderActionsBox()}
        {filteredSlides.length === 0 && <NotFoundV2 />}
        {filteredSlides.length > 0 && this.renderSlidesByType(filteredSlides)}
        <div className={styles.slides_footer}>
          <button
            className={styles.cancel_btn}
            onClick={this.handleCancelAddSlide}
          >
            {_("cancel")}
          </button>
          <button
            className={classnames(
              styles.validate_btn,
              !activatedSlide && styles.disabled_btn
            )}
            onClick={() => this.handleValidateAction()}
          >
            {_("validate")}
          </button>
        </div>
      </Fragment>
    );
  }
}

export default SlidesList;



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/SlidesList.js